























































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { INavMenuItem } from '@/types/data-objects/global'

/* API */

export default Vue.extend({
  name: 'BreadcrumbFilterPicker',
  props: {
    deemphasized: {
      type: Boolean,
      default: false,
    },
    defaultFilters: {
      type: Array as () => INavMenuItem[],
      default: null,
    },
    customFilters: {
      type: Array as () => INavMenuItem[],
      default: null,
    },
    currentFilter: {
      type: Object as () => INavMenuItem,
      required: true,
    },
    totalItemCount: {
      type: Number,
      default: null,
    },
    allowFilterDelete: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      filtersLoaded: false,
      showDropdown: false,
      lazyLoadedDefaultFilters: [] as INavMenuItem[],
      lazyLoadedCustomFilters: [] as INavMenuItem[],
    }
  },

  computed: {
    hasCustomFilters(): boolean {
      return this.customFilters.length > 0
    },
    internalDefaultFilters(): INavMenuItem[] {
      if (this.defaultFilters) {
        return this.defaultFilters
      }
      if (this.lazyLoadedDefaultFilters.length > 0) {
        return this.lazyLoadedDefaultFilters
      }
      return [] as INavMenuItem[]
    },
    internalCustomFilters(): INavMenuItem[] {
      if (this.customFilters) {
        return this.customFilters
      }
      if (this.lazyLoadedCustomFilters.length > 0) {
        return this.lazyLoadedCustomFilters
      }
      return [] as INavMenuItem[]
    },
  },

  watch: {
    defaultFilters: {
      immediate: true,
      handler(val) {
        this.filtersLoaded = val
      },
    },
  },

  methods: {
    getFilterCount(item: INavMenuItem) {
      if (item.count === null) {
        return ''
      }

      if (item.count > 999) {
        return '999+'
      }

      if (item.count === 0) {
        return ''
      }

      return item.count
    },
    handleFilterSelect(value: string) {
      this.$emit('change-filter', value)
      // @ts-ignore
      this.$refs.filterDropdown.handleClose()
    },
    handleCustomFilterDelete(value: string) {
      this.$emit('delete-custom-filter', value)
    },
  },
})
